// cookiesUtils.js

// Function to set a cookie with expiration time in hours
export const setCookie = (name, value, hours) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + hours * 60 * 60 * 1000); // Expiration time in milliseconds
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
};

// Function to get a cookie by name
export const getCookie = (name) => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null; // Return null if cookie not found
};

// Function to erase a cookie by name
export const eraseCookie = (name) => {
  document.cookie = `${name}=; Max-Age=-99999999;`;
};
